module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_79-59d8ae7558568e0c2bae3f3dcdfa8baf.png";